var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductNotFound = function SvgProductNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160c44.183 0 80-35.817 80-80S124.183 0 80 0 0 35.817 0 80s35.817 80 80 80Z",
    fill: "#DEDEFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ProductNotFound_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 160c44.183 0 80-35.817 80-80S124.183 0 80 0 0 35.817 0 80s35.817 80 80 80Z",
    fill: "#FEF7EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ProductNotFound_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 159.999H32V56.533a17.086 17.086 0 0 0 17.067-17.067h61.866a16.966 16.966 0 0 0 5.004 12.062A16.958 16.958 0 0 0 128 56.533v103.466Z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.002 108.801c14.138 0 25.6-11.462 25.6-25.6 0-14.139-11.462-25.6-25.6-25.6-14.139 0-25.6 11.461-25.6 25.6 0 14.138 11.461 25.6 25.6 25.6Z",
    fill: "#5D5BEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.051 95.268 80 86.217l-9.051 9.05-3.017-3.016 9.051-9.051-9.051-9.051 3.017-3.017L80 80.183l9.051-9.051 3.017 3.017-9.051 9.051 9.051 9.05-3.017 3.018Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.866 115.2H66.133a3.2 3.2 0 0 0 0 6.4h27.733a3.2 3.2 0 1 0 0-6.4ZM103.468 128H56.535a3.2 3.2 0 0 0 0 6.4h46.933a3.2 3.2 0 0 0 0-6.4Z",
    fill: "#9E9DF2"
  })));
};
export default SvgProductNotFound;